import { createSelector } from 'reselect'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable, createParallelGuard, connectLoadable } from 'helpers/loadableHelpers'
import { LineChart, LineChartInnerOwnProps, LineChartInnerStateProps } from 'components/features/pfm/LineChart/LineChart'
import LineChartLoadingOverlay from 'components/atoms/preloaders/LineChartLoadingOverlay'
import { prepareTrendProps } from 'helpers/trendHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { createOwnPropsSelector } from 'selectors/globalSelectors'
import { memberGenericTrendSelector, yourPeersGenericTrendsSelector, othersGenericTrendsSelector } from 'selectors/genericSelectors'
import { peergroupGenericTrendsGuard, memberGenericTrendsGuard } from 'guards/genericGuards'
import { GenericTrendOwnProps } from 'interfaces/trend'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { selectedRelationSelector } from 'selectors/peergroupSelectors'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

type GenericTrendModuleContainerProps =
  & GenericTrendOwnProps
  & LineChartInnerOwnProps

const createMapStateToProps = () =>
  createSelector(
    memberGenericTrendSelector,
    yourPeersGenericTrendsSelector,
    othersGenericTrendsSelector,
    selectedRelationSelector,
    isMobileSelector,
    createOwnPropsSelector<GenericTrendModuleContainerProps>(),
    withComparisonSelector,
    (memberTrend, peersTrend, othersTrend, selectedRelation, isMobile, ownProps, withComparison): LineChartInnerStateProps => {
      if (!memberTrend) {
        throw createForgottenGuardError('GenericTrendModuleContainer', 'memberGenericTrendsGuard')
      }

      if (!peersTrend || !othersTrend) {
        throw createForgottenGuardError('GenericTrendModuleContainer', 'peergroupGenericTrendsGuard')
      }

      if (!selectedRelation) {
        throw createForgottenGuardError('GenericTrendModuleContainer', 'peergroupsGuard')
      }

      return prepareTrendProps({ memberTrend, peersTrend, othersTrend }, ownProps, selectedRelation.name, isMobile, withComparison)
    }
  )

const guards: Guards<GenericTrendModuleContainerProps> = [
  peergroupsGuard,
  createParallelGuard(memberGenericTrendsGuard, peergroupGenericTrendsGuard),
]

const T = connectShadedLoadable<
  LineChartInnerStateProps,
  {},
  LineChartInnerOwnProps,
  GenericTrendModuleContainerProps
>(createMapStateToProps, undefined, guards, LineChartLoadingOverlay)(LineChart)
export default T

export const GenericTrendModuleContainer = connectLoadable<
  LineChartInnerStateProps,
  {},
  LineChartInnerOwnProps,
  GenericTrendModuleContainerProps
>(guards)(createMapStateToProps)(LineChart)

